import { FormEvent, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { MultiLineTextWithValidation, NumberWithValidation, SlideOutModal, SlideOutModalProps, TextWithValidation } from "../../../components";
import { ActivityModel } from "../../../data/entities";
import { SubdisciplinePicker } from "../../../components/form/dropdown";
// import { SubdisciplinePicker } from "../../../../components/form/dropdown";

export interface AddActivityModalProps extends SlideOutModalProps {
  onSubmit: (data: any) => void;
}

export function AddActivityModal(props: Readonly<AddActivityModalProps>) {
  const [validated, setValidated] = useState(false);
  const [values, setValues] = useState({
    name: "",
    code: "",
  } as ActivityModel);

  const formRef = useRef<HTMLFormElement>(null);
  const formSubmitRef = useRef<HTMLButtonElement>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setValidated(true);
      props.onSubmit.call(null, values);
      resetForm();
    } else {
      setValidated(false);
    }
  };

  const resetForm = () => {
    setValues({
      name: "",
      code: "",
      subdisciplineId: 0,
      description: ""
    } as ActivityModel);
    setValidated(false);
  }

  return (
    <SlideOutModal {...props}
      title={`Add New Activity`}
      footer={<div className="container p-0">
        <div className="row g-0">
          <div className="col-6 pe-2">
            <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
              Cancel
            </Button>
          </div>
          <div className="col-6 ps-2">
            <Button onClick={() => formSubmitRef.current?.click()} variant="primary" className="w-100">
              Add
            </Button>
          </div>
        </div>
      </div>}>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="col-12">
          <TextWithValidation
            id="name"
            required={true}
            label="Name"
            initialValue={values.name}
            onChangeText={(v) => setValues({ ...values, name: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="code"
            required={true}
            label="Code"
            initialValue={values.code}
            onChangeText={(v) => setValues({ ...values, code: v })}
          />
        </div>
        <div className="col-12">
          <SubdisciplinePicker
            id="subdisciplineId"
            label="Subdiscipline"
            onSelect={(v) => setValues({ ...values, subdisciplineId: Number(v)})}
            initialValue={`${values.subdisciplineId}`}
          />
        </div>
        <div className="col-12">
          <TextWithValidation
            id="duration"
            type="number"
            integer={true}
            label="Duration"
            initialValue={values.duration}
            onChangeText={(v) => setValues({ ...values, duration: Number(v) })}
          />
        </div>
        <div className="col-12">
          <MultiLineTextWithValidation
            id="description"
            label="Description"
            initialValue={values.description}
            onChangeText={(v) => setValues({ ...values, description: v })}
          />
        </div>
        <Button ref={formSubmitRef} type="submit" className="d-none" />
      </Form>
      {props.children}
    </SlideOutModal>
  );
}

export default AddActivityModal;

